import * as React from 'react';
import {
    Paper,
    Divider,
    List,
    ListSubheader,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
} from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import ListItemButton from "@mui/material/ListItemButton";

interface OwnProps {
    paperProps?: any;
    singles: string[];
}

interface InjectedRouterProps {
    navigate: ReturnType<typeof useNavigate>;
}

type Props = OwnProps & InjectedRouterProps;

class SingleListInner extends React.Component<Props,any>{

    handleItemClick = (key: string) => (e: any)=>{
        this.props.navigate(`singles/${key}`);
    }

    render(){
        return (
            <Paper {...this.props.paperProps}>
                <List component="nav" subheader={<ListSubheader>Singles</ListSubheader>}>
                    <Divider />
                    {(this.props.singles||[]).map((single, i) => {
                        return (
                            <ListItemButton key={single} onClick={this.handleItemClick(single)} divider={true}>
                                <ListItemText primary={single} />
                                {/* <ListItemSecondaryAction>
                                    <IconButton onClick={this.handleSingleMoreClick} data-key={single}>
                                        <MoreVertIcon />
                                    </IconButton>
                                </ListItemSecondaryAction> */}
                            </ListItemButton>
                        );
                    })}
                </List>
            </Paper>
        );
    }
}

export function SingleList(props: OwnProps){
    const navigate = useNavigate();
    return <SingleListInner {...props} navigate={navigate} />;
}
